// REST client for the server's notification feed. The live path is WS
// (notification:new / notifications:snapshot, handled in
// notificationsStore.js); these are the fetch-on-open and mark-read verbs.
import { api } from './serverClient';

export async function fetchNotifications({ limit = 50 } = {}) {
  const res = await api.get(`/notifications?limit=${encodeURIComponent(limit)}`);
  return { items: res?.items || [], unread: Number(res?.unread) || 0 };
}

export async function markNotificationsRead(ids) {
  return api.post('/notifications/read', { ids });
}

export async function markAllNotificationsRead() {
  return api.post('/notifications/read', { all: true });
}

export async function resolveNotification(id) {
  return api.post(`/notifications/${encodeURIComponent(id)}/resolve`, {});
}
